export const REFRESH_USER_COUNT = 'REFRESH_USER_COUNT';

import { get, put, post, destroy, upload } from 'utils/fetchRequest';

export const uploadImage = async (data) => {
    try {
        const result = await upload('files/time', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getTimeList = async (searchText) => {
    try {
        const result = await get(`time${searchText ? `?search=${searchText}` : ''}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getTimeContent = async (newsId) => {
    try {
        const result = await get(`time/${newsId}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createTime = async (data) => {
    try {
        const result = await post('time', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateTime = async (id, data) => {
    try {
        const result = await put(`time/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deleteTime = async (id) => {
    try {
        const result = await destroy(`time/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const setSpecial = async (id, data) => {
    try {
        const result = await put(`time/special/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

